<section class="header-btn-wrapper">
    <button nz-button nzType="primary" (click)="showItem()">Create Voice Clone</button>
</section>
<ag-grid-angular
  #agGrid
  domLayout='autoHeight'
  class="ag-theme-alpine"
  [rowData]="data"
  [columnDefs]="columnDefs"
  rowSelection="multiple"
  [defaultColDef]="defaultColDef"
  [rowClassRules]="rowClassRules"
  [pagination]="true"
  [suppressRowClickSelection]="true"
  (gridReady)="onGridReady($event)"
  [enableCellTextSelection]="true"
  >
</ag-grid-angular>
